import axios from 'axios';

const UNSUBSCRIBE_PATH = '/api/unsubscribe';

class UnsubscribeService {
  async unsubscribe(guid) {
    const url = `${UNSUBSCRIBE_PATH}/${encodeURIComponent(guid)}`;
    const response = await axios.post(url);
    return response;
  }
}

export default new UnsubscribeService();
